import moment from 'moment';

/**
 * Checks if user has valid discount
 *
 * @param   {number}  discountEnd  Discount end timestamp
 *
 * @returns  {boolean}              If discount has ended
 */
export default (discountEnd) => discountEnd ? moment.unix(discountEnd).isAfter(moment().unix()) : true;
